// extracted by mini-css-extract-plugin
module.exports = {"ComingSoon":"factories-main_ComingSoon__4MBpY"};